import moment from 'moment';

export const validateHistoricalDates = (dates, now = new Date()) => {
  const today = moment(now).startOf('day');
  const earliest = today.clone().subtract(10, 'years');
  if (!dates.length || dates.some((date) => !date || !moment(date).isValid())) {
    return 'Enter a valid date for every record.';
  }
  if (dates.some((date) => !moment(date).isBefore(today) || moment(date).isBefore(earliest))) {
    return 'Record dates must be before today and within the last 10 years.';
  }
  const uniqueDates = new Set(dates.map((date) => moment(date).format('YYYY-MM-DD')));
  if (uniqueDates.size !== dates.length) {
    return 'Use a different completion date for each record.';
  }
  return '';
};

export const saveHistoricalDates = async (dates, saveRecord) => {
  const results = await Promise.allSettled(dates.map((date) => Promise.resolve().then(() => saveRecord(date))));
  const failedDates = dates.filter((date, index) => {
    const result = results[index];
    return result.status !== 'fulfilled' || !result.value || result.value instanceof Error || !result.value.id;
  });
  return {
    failedDates,
    savedCount: dates.length - failedDates.length,
  };
};
